import { Routes } from "@angular/router";
import { MainComponent } from "./layout/main/main.component";
import { AuthGuardFxn } from "./core/guards/auth.guard";

export const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "auth/login",
  },
  {
    path: "",
    component: MainComponent,
    canActivate: [AuthGuardFxn],
    loadChildren: () =>
      import("./modules/afterLoginpages/module-routes").then((m) => m.routes),
  },
  {
    path: "auth",
    canActivate: [AuthGuardFxn],
    loadChildren: () =>
      import("./modules/auth/auth-routes").then((m) => m.routes),
  },
  {
    path: 'content',
    loadChildren: () => import(
      './cms-links/cms-links-routing.module'
    ).then((main) => main.CmsLinksRoutingModule)
  }
];
